import type { Permission } from '@ztechapps/common.contract'

export const milkTicketPermissions = {
  canView: {
    value: 'milkTicket.canView',
    label: 'Can View',
    description: 'No modification can be done to the milk ticket, only viewing of details.',
  } satisfies Permission,

  canEdit: {
    value: 'milkTicket.canEdit',
    label: 'Can Edit',
    description: 'Can modify the records for all fields of milk ticket',
  } satisfies Permission,

  canDelete: {
    value: 'milkTicket.canDelete',
    label: 'Can Delete',
    description: 'Can delete the records for all fields of milk ticket. This will delete entire record and cannot be recovered.',
  } satisfies Permission,

  canPrintManifest: {
    value: 'milkTicket.canPrintManifest',
    label: 'Can Print Manifest',
    description: 'Allows the user to print the manifest for a milk ticket.',
  } satisfies Permission,

  canSignManifest: {
    value: 'milkTicket.canSignManifest',
    label: 'Can Sign Manifest',
    description: 'Allows the user to sign the manifest for a milk ticket.',
  } satisfies Permission,

  canSignPickups: {
    value: 'milkTicket.canSignPickups',
    label: 'Can Sign Pickups',
    description: 'Allows the user to sign pickups on a milk ticket.',
  } satisfies Permission,
}
